export const CONVERSATION_SETTING_KEYS = [
    'gifs_disabled',
    'gif_content_filter',
    'custom_emojis_disabled',
    'persistent_search_cache_disallowed',
    'allow_skip_moderation',
    'allow_audio_calls',
    'allow_video_calls',
    'allow_screenshare',
];
const CONVERSATION_SETTING_KEY_SET = new Set(CONVERSATION_SETTING_KEYS);
const BOOLEAN_SETTING_VALUES = new Set(['enabled', 'disabled']);
const FILTER_SETTING_VALUES = new Set(['off', 'low', 'medium', 'high']);
/** Visible checkbox state for conversation-admin toggles (not the internal *Disabled flag). */
export function conversationSettingToggleValue(checked) {
    return checked ? 'enabled' : 'disabled';
}
function allowlistedSettingFields(setting, value) {
    if (!setting || value == null || value === '' || !CONVERSATION_SETTING_KEY_SET.has(setting)) {
        return undefined;
    }
    const key = setting;
    if (key === 'gif_content_filter') {
        if (!FILTER_SETTING_VALUES.has(value))
            return undefined;
    }
    else if (!BOOLEAN_SETTING_VALUES.has(value)) {
        return undefined;
    }
    return { setting: key, value };
}
/**
 * Plaintext fields the server may store on a system message: type, identity
 * ids, and allowlisted conversation-setting keys/values. Display names belong
 * in {@link EncryptedSystemEventPayload}.
 */
export function stubSystemEvent(event) {
    const stub = {
        type: event.type,
        identityId: event.identityId,
    };
    if (event.actorIdentityId)
        stub.actorIdentityId = event.actorIdentityId;
    const settingFields = allowlistedSettingFields(event.setting, event.value);
    if (settingFields) {
        stub.setting = settingFields.setting;
        stub.value = settingFields.value;
    }
    return stub;
}
/** Cap on identities returned in a group invite hover preview. */
export const GROUP_INVITE_PREVIEW_MEMBER_LIMIT = 10;
/** Cap on other pending invitees named in a group invite hover preview. */
export const GROUP_INVITE_PREVIEW_INVITED_LIMIT = 5;
//# sourceMappingURL=conversations-types.js.map